const errors: Record<string, string> = {
  '500': 'Internal Server Error',
  '502': 'Bad Gateway',
  '503': 'Service Unavailable',
  '504': 'Gateway Timeout',
  //
  '400': 'Bad Request',
  '401': 'Unauthorized',
  '403': 'Access denied',
  '404': 'Not Found',
};

export default errors;
